var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"status"},[(!_vm.isBlocked)?_c('v-col',{attrs:{"cols":"12"}},[_c('WidgetBonuses')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }